import { GET_GROUP, GET_GROUP_DATA, NEW_GROUP_INIT, GET_GROUP_UTYPE_UNIT_LI, GET_GROUP_UTYPE_UNIT_LI_DATA } from '../constants';
import DlGroup from '../models/DlGroup';
import PhotoSer from '../models/PhotoSer';
import { updateObject, createReducer } from './common';

export const initialState = { 
    dlGroupSlug: '', 
    dlGroup: new DlGroup(),
    uType: '',
    photoSer: {
        slug: '',
        ser: new PhotoSer(),
        serLi: []
    }
};

const handler = {
    [GET_GROUP]: (state, action) => updateObject(state, { dlGroupSlug: action.payload, dlGroup: new DlGroup() }),
    [GET_GROUP_DATA]: (state, action) => updateObject(state, { dlGroup: action.payload }),
    [NEW_GROUP_INIT]: () => ({ ...initialState }),
    [GET_GROUP_UTYPE_UNIT_LI]: (state, action) => updateObject(state, { dlGroupSlug: action.payload.dlGroupSlug, dlGroup: new DlGroup(), uType: action.payload.uType }),
    [GET_GROUP_UTYPE_UNIT_LI_DATA]: (state, action) => updateObject(state, { dlGroup: action.payload })
}

export const dlGroupReducer = createReducer(initialState, handler);